(function () {
  var configEl = document.querySelector('[data-theme-globals]');

  if (configEl) {
    try {
      var config = JSON.parse(configEl.textContent || '{}');

      window.shopUrl = config.shopUrl || '';
      window.routes = config.routes || {};
      window.cartStrings = config.cartStrings || {};
      window.variantStrings = config.variantStrings || {};
	      window.quickOrderListStrings = config.quickOrderListStrings || {};
	      window.accessibilityStrings = config.accessibilityStrings || {};
	      // Merge instead of overwrite: sections/snippets register their own namespaces
	      // via inline <script> blocks before this deferred file runs.
	      window.gwaStrings = Object.assign(window.gwaStrings || {}, config.gwaStrings || {});
	      window.gwaMoneyFormat = config.gwaMoneyFormat || '';
      window.gwaMoneyFormatWithCurrency = config.gwaMoneyFormatWithCurrency || '';
    } catch (error) {
      console.warn('Theme globals config failed:', error);
    }
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }
})();
